import React from 'react';

const Loader = () => <div className="loader" />;

export default Loader;